import { isAdminOrEmployee } from '~/utils/adminPermission';

import isProd from '~/utils/isProd';

export function isToursCommandCentreEnabled(
  user: { roles?: Array<string> | null; email?: string | null } | null | undefined,
): boolean {
  if (!user) {
    return false;
  }

  if (!isProd()) {
    return true;
  }

  // Mirrors the reporting API's employee-or-admin rule.
  return Boolean(isAdminOrEmployee(user));
}
